export const PATH_JOINER = '$@'

export const getBitPath = (path: string, nextKeyName?: string) => {
    const bitPath = path.split(PATH_JOINER)
    if (nextKeyName) bitPath.push(nextKeyName)
    return bitPath
}